module.exports = __webpack_public_path__ + "img/todos_180.6aefe20f.webp";